import { Button, Form, Input, Modal, Radio, Space, Table } from "antd";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { couponSelector } from "../../feature/partner-details/partnerDetailsSelector";
import {
  createCouponRequest,
  getCouponRequest,
  removeCouponRequest,
  updateCouponRequest,
} from "../../feature/partner-details/partnerDetailsSlice";
import { appConfig } from "../../utils/appConfig";

const CouponCodes = ({ isPartner, id }) => {
  const [selectedCouponUpdate, setSelectedCouponUpdate] = useState();
  const [selectedCouponDelete, setSelectedCouponDelete] = useState();
  const [displayRemoveModal, setDisplayRemoveModal] = useState(false);
  const { listCoupon, isGetCoupon, isCreateCoupon, isUpdateCoupon } =
    useSelector(({ partnerDetailsState }) =>
      couponSelector(partnerDetailsState)
    );
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onFormFinish = (values) => {
    let allowRoles =
      values.allowRoles === "admin-only" ? ["admin"] : ["admin", "user"];
    selectedCouponUpdate
      ? dispatch(
          updateCouponRequest({
            ...values,
            allowRoles,
            partner: id,
            _id: selectedCouponUpdate._id,
          })
        )
      : dispatch(createCouponRequest({ ...values, allowRoles, partner: id }));
  };

  const onUpdateCoupon = (item) => {
    setSelectedCouponUpdate(item);
    form.setFieldsValue({
      ...item,
      allowRoles:
        item.allowRoles.includes("admin") && item.allowRoles.includes("user")
          ? "admin-and-user"
          : "admin-only",
    });
  };

  const onCancelUpdate = () => {
    setSelectedCouponUpdate(undefined);
    form.resetFields();
  };

  const onConfirmCouponRemove = () => {
    selectedCouponDelete && dispatch(removeCouponRequest(selectedCouponDelete));
    setSelectedCouponDelete(undefined);
    setDisplayRemoveModal(false);
  };

  const columns = useMemo(() => {
    const result = [
      {
        title: "Date",
        dataIndex: "updatedAt",
        key: "updatedAt",
        render: (value) => moment(value).format("DD MMM YYYY"),
      },
      {
        title: "Subject",
        dataIndex: "subject",
        key: "subject",
      },
      {
        title: "Content",
        dataIndex: "content",
        key: "content",
        render: (values) => {
          if (!values) return "";
          return (
            <ul className="pre-qualification-ul">
              {values.split("\n").map((value, key) => (
                <li key={key}>{value}</li>
              ))}
            </ul>
          );
        },
      },
      {
        title: "Privacy",
        dataIndex: "allowRoles",
        key: "allowRoles",
        render: (values) => {
          if (values.includes("admin") && values.includes("user")) {
            return "Admin & Partner";
          }
          return "Admin";
        },
      },
      {
        title: "Action",
        key: "action",
        render: (_, item) => (
          <Space size="middle">
            <span className="link-pointer" onClick={() => onUpdateCoupon(item)}>
              Edit
            </span>
            <span
              className="pointer ant-typography ant-typography-danger"
              onClick={() => {
                setSelectedCouponDelete(item);
                setDisplayRemoveModal(true);
              }}
            >
              Delete
            </span>
          </Space>
        ),
      },
    ];
    return isPartner
      ? result.filter(
          (item) => item.key !== "action" && item.key !== "allowRoles"
        )
      : result;
    // eslint-disable-next-line
  }, [isPartner]);

  useEffect(() => {
    dispatch(getCouponRequest(id));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="coupon-code-container">
      {!isPartner && (
        <Form
          form={form}
          className="item-info-container mt-25 max-w-1100"
          onFinish={onFormFinish}
        >
          <div className="item-info">
            <Form.Item
              name="subject"
              rules={[{ required: true, message: "Please input subject!" }]}
              label="Subject"
              className="subject-input"
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="content"
              rules={[{ required: true, message: "Please input content!" }]}
              label="Content"
              className="content-input"
            >
              <Input.TextArea rows={4} />
            </Form.Item>
            <div className="privacy-and-button">
              <Form.Item
                name="allowRoles"
                rules={[{ required: true, message: "Please choose privacy!" }]}
                className="privacy-radio"
              >
                <Radio.Group>
                  <Radio value="admin-only">Admin only</Radio>
                  <Radio value="admin-and-user">{"Admin & Partner"}</Radio>
                </Radio.Group>
              </Form.Item>
              {selectedCouponUpdate ? (
                <div className="d-flex action">
                  <Button
                    type="primary"
                    className=""
                    htmlType="submit"
                    loading={isUpdateCoupon}
                  >
                    Update Item
                  </Button>{" "}
                  <Button
                    className="ml-5"
                    loading={isUpdateCoupon}
                    onClick={() => onCancelUpdate()}
                  >
                    Cancel
                  </Button>
                </div>
              ) : (
                <Button
                  type="primary"
                  className="action"
                  htmlType="submit"
                  loading={isCreateCoupon}
                >
                  Add New Item
                </Button>
              )}
            </div>
          </div>
        </Form>
      )}
      <Table
        className="mt-25"
        columns={columns}
        dataSource={listCoupon}
        bordered
        pagination={{
          pageSize: appConfig.PAGE_SIZE,
        }}
        loading={isGetCoupon}
        rowKey="_id"
      />
      {displayRemoveModal && (
        <Modal
          title="Are you sure?"
          visible={true}
          width={"50%"}
          className="modal-w-600"
          onOk={onConfirmCouponRemove}
          onCancel={() => {
            setDisplayRemoveModal(false);
            setSelectedCouponDelete(undefined);
          }}
        >
          <p>
            {
              "Do you really want to delete this coupon & note? This process cannot undone."
            }
          </p>
        </Modal>
      )}
    </div>
  );
};

export default CouponCodes;
